import { Component, OnInit, Renderer2, forwardRef, ViewChild, Input, ViewEncapsulation, ChangeDetectionStrategy, OnDestroy, ViewContainerRef, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Honeycomb } from 'src/app/shared/honeycomb-api/honeycomb-api';
import { Code } from '../code.model';
import { ProductAttributeTypeWithValue } from '../product.model';
import { CodeLookupCacheService } from 'src/app/shared/code-lookup-cache-service';
import { IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
  selector: 'hc-grid-multiselect-editor',
  templateUrl: './grid-multiselect-editor.component.html',
  styleUrls: ['./grid-multiselect-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => GridMultiselectEditorComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridMultiselectEditorComponent implements OnInit, ICellEditorAngularComp, AfterViewInit {

  @ViewChild('container', { read: ViewContainerRef, static: true }) public container;

  private params: any;
  public items: any[];

  public valueStr: string = null;
  public valueObj: any = null;
  public meta: any = null;

  public codeValues: Array<Code> = [];
  public codeListReady = false;
  private paramsData: ProductAttributeTypeWithValue;

  public filterText: string = '';

  @ViewChild('codeListSelect', {static: false}) codeListSelect: ElementRef;


  constructor(private cd: ChangeDetectorRef,
    private codeChacheService: CodeLookupCacheService) {
  }

  ngOnInit(): void {
  }

  // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
  ngAfterViewInit() {
      window.setTimeout(() => {
          this.container.element.nativeElement.focus();
          const ePopup = this.container.element.nativeElement;

          // Zjisti pozici buňky
          const cellRect = this.params.eGridCell.getBoundingClientRect();
          const popupHeight = 250;

          const spaceBelow = window.innerHeight - cellRect.bottom;
          if (spaceBelow < popupHeight) {
            // Málo místa dole => posuň nad buňku
            ePopup.style.top = (cellRect.top - popupHeight) + 'px';
          }
      });
      this.cd.detectChanges();
  }

  async agInit(params: any) {
      this.params = params;
      this.paramsData = params.node.data as ProductAttributeTypeWithValue;
      if(this.paramsData.codeListId){
          this.valueStr = this.paramsData.value;

          let splitValue = this.paramsData?.value?.split(',');

          this.codeChacheService.cacheReady.subscribe(() => {
              this.setCodeLists();
              this.cd.detectChanges();
          });
          
          this.setCodeLists();

          const seen = new Set<string>();
          this.items = this.codeValues.map(i => ({
            id: i.codeKey,
            name: i.codeValue,
            selected: splitValue?.includes(i.codeKey)
          })).filter(item => {
            if (seen.has(item.id)) return false;
            seen.add(item.id);
            return true;
          });
        
          this.items.sort((a,b) => (a.selected === b.selected) ? 0 : a.selected ? -1 : 1); // selected values pushed on top of list

          this.cd.detectChanges();
      }
      else{
          this.valueObj = params.value;

          this.meta = this.params.node.data[-1];

          this.items = this.meta.items.map(i => {
            let res = {
              id: null,
              name: null,
              selected: false
            };
            res.id = i[this.meta.valueProp];
            res.name = i[this.meta.displayProp];
            res.selected = params.value.jobPermissionTypeIDs.indexOf(i[this.meta.valueProp]) > -1
            return res;
          })
          
          this.setCodeLists();
        
          this.cd.detectChanges();
      }
  }

  setCodeLists() {
      this.codeValues = this.codeChacheService.getCodeListItems(this.paramsData.codeListId);
      this.codeListReady = (this.codeValues != null);
      window.setTimeout(() => {
          if (!!this.codeListSelect) {
              this.codeListSelect.nativeElement.focus();
          }
      });
  }

  getValue(): any {
    if(this.paramsData.codeListId){
      let value = this.items.filter(i => !!i.selected).map(i => i.id);//.join(',');
      return value;
    }
    else{
      this.valueObj.jobPermissionTypeIDs = this.items.filter(i => !!i.selected).map(i => i.id);
      return this.valueObj;
    }
  }

  isPopup(): boolean {
      return true;
  }

  get filteredItems(): any[] {
    if (!this.filterText) return this.items;
    const lower = this.filterText.toLowerCase();
    return this.items.filter(i => i.name.toLowerCase().includes(lower));
  }

  public boolCheckedChanged($event: MatCheckboxChange) {
      this.valueStr = $event.checked ? 'True' : 'False';
  }

  public close() {
      this.params.api.stopEditing();
  }

  public listOptionSelected($event, option: any) {
      $event.stopPropagation();
      this.valueStr = option.codeKey;
  }

  public focusIn() {
      console.log('FocusIn');
  }

  public focusOut() {
      console.log('FocusOut');
  }

  public optionSelected($event) {
      console.log($event);
  }

  onKeyDown(event): void {
      //   let key = event.which || event.keyCode;
      //   if (key === 37 ||  // left
      //       key === 39) {  // right
      event.stopPropagation();
      //   }
  }

}
